import dayjs from 'dayjs'
import advancedFormatPlugin from 'dayjs/plugin/advancedFormat'
import durationPlugin from 'dayjs/plugin/duration'
import isSameOrAfterPlugin from 'dayjs/plugin/isSameOrAfter'
import isTodayPlugin from 'dayjs/plugin/isToday'
import isTomorrowPlugin from 'dayjs/plugin/isTomorrow'
import isYesterdayPlugin from 'dayjs/plugin/isYesterday'
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat'
import relativeTimePlugin from 'dayjs/plugin/relativeTime'
import timezonePlugin from 'dayjs/plugin/timezone'
import updateLocalePlugin from 'dayjs/plugin/updateLocale'
import utcPlugin from 'dayjs/plugin/utc'
import weekOfYearPlugin from 'dayjs/plugin/weekOfYear'
import weekYearPlugin from 'dayjs/plugin/weekYear'

dayjs.extend(advancedFormatPlugin)
dayjs.extend(durationPlugin)
dayjs.extend(isSameOrAfterPlugin)
dayjs.extend(isTodayPlugin)
dayjs.extend(isTomorrowPlugin)
dayjs.extend(isYesterdayPlugin)
dayjs.extend(localizedFormatPlugin)
dayjs.extend(relativeTimePlugin)
dayjs.extend(timezonePlugin)
dayjs.extend(updateLocalePlugin)
dayjs.extend(utcPlugin)
dayjs.extend(weekOfYearPlugin)
dayjs.extend(weekYearPlugin)

export { dayjs }
export { Dayjs } from 'dayjs'
